import React, { useContext, useState, useEffect } from "react";
import Form from "react-bootstrap/Form";

const CheckBoxCell = ({ props }) => {
  let data = props.data;
  let colIndex = props.colIndex;
  let textValue = data[colIndex];
  let [checkedText, setCheckedText] = useState(textValue ?? false);
  let isDisabled = props?.schema?.disabled || false;

  const updateCheckboxValue = async (e) => {
    let id = data[0];
    let setObjValue = {
      id: id,
      selected: e.currentTarget.checked,
    };
    let temp = [...props.tableProps.tableSelectedItems];
    setCheckedText(setObjValue.selected);
    if (setObjValue.selected) {
      if (temp.indexOf(id) === -1) {
        temp.push(id);
      }
    } else {
      temp.splice(temp.indexOf(id), 1);
    }
    await props.tableProps.setTableSelectedItems(temp);
  };

  useEffect(() => {
    let isSelected = props.tableProps.tableSelectedItems.indexOf(data[0]) > -1;
    setCheckedText(isSelected);
  }, [props.tableProps.tableSelectedItems]);

  return (
    <Form.Check
      type="checkbox"
      disabled={isDisabled ? true : false}
      onChange={updateCheckboxValue}
      checked={checkedText}
      id={`indi-table-item-${data[0]}`}
    />
  );
};

export default CheckBoxCell;
